import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import './SemiconMech.css';

const SemiconLayout = ({ kicker, title, lead, children }) => {
  useEffect(() => {
    document.documentElement.classList.add('qn-home-html');
    document.body.classList.add('qn-home-body');
    return () => {
      document.documentElement.classList.remove('qn-home-html');
      document.body.classList.remove('qn-home-body');
    };
  }, []);

  return (
    <div className="sm-lab">
      <Header />
      <main className="sm-main">
        <Link to="/virtuallabs/semicon-mech" className="sm-back">← Back-end line</Link>
        {kicker && <p className="sm-kicker">{kicker}</p>}
        <h1>{title}</h1>
        {lead && <p className="sm-lead">{lead}</p>}
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default SemiconLayout;
